import React, { useState, useRef } from 'react';
import IconPicker from '../../IconPicker';
import { renderIcon } from '../../../FlowchartView/utils/renderIcon';
import { CampaignItemIcon } from '../../../../Sidebar/icons';

/**
 * CampaignIcon - Clickable campaign icon with picker
 * Shows current icon or default, opens IconPicker on click
 */
const CampaignIcon = ({ 
  icon, 
  onIconChange,
  classPrefix = 'campaign-header',
}) => {
  const [showIconPicker, setShowIconPicker] = useState(false);
  const [iconPickerPosition, setIconPickerPosition] = useState(null);
  const iconRef = useRef(null);

  const hasIcon = !!icon;

  const handleIconClick = (e) => {
    e.stopPropagation();
    if (iconRef.current) {
      const rect = iconRef.current.getBoundingClientRect();
      setIconPickerPosition({
        x: rect.left,
        y: rect.bottom + 8,
      });
    }
    setShowIconPicker(true);
  };

  const handleIconChange = (newIcon) => {
    onIconChange?.(newIcon);
    // Don't close picker - let user set both icon and color
  };

  return (
    <>
      <button
        ref={iconRef}
        className={`${classPrefix}__icon ${hasIcon ? `${classPrefix}__icon--has-icon` : ''}`}
        onClick={handleIconClick}
        title={hasIcon ? "Change icon" : "Add icon"}
      >
        {hasIcon ? (
          renderIcon(icon, { 
            size: '20px',
            fallback: <CampaignItemIcon size={20} />
          })
        ) : (
          <CampaignItemIcon size={20} />
        )}
      </button>

      {showIconPicker && (
        <IconPicker
          currentIcon={icon}
          onIconChange={handleIconChange}
          onIconDeleted={() => handleIconChange(null)}
          onClose={() => setShowIconPicker(false)}
          position={iconPickerPosition}
        />
      )}
    </>
  );
};

export default CampaignIcon;
